<!-- 账户余额-->
<template>
  <div class="page" v-cloak>
    <van-nav-bar left-arrow fixed title="我的账户" id="nav-bar" @click-left="onClickLeft"></van-nav-bar>
    <div class="header-b">
      <!-- <p class="user-no">用户：15650421107</p> -->
      <h3 class="price">{{points | numToCash}}</h3>
      <p class="tips">账户余额</p>
      <p class="h-btn click"><span @click="goPage({name:'balance-log-list',qurey:{}})">查看全部交易记录</span></p>
    </div>
    <h3 class="list-tips">近期交易</h3>
    <div class="list">
      <text-row-balance v-for="(item, index) in pointsLogs" :balance-data="item" :key="index"></text-row-balance>
    </div>
  </div>
</template>

<script type="text/babel">
import TextRowBalance from "@/components/text-row-balance/text-row-balance.vue";
export default {
  name: 'MineBalance',
  components: { TextRowBalance },
  props: {},
  data() {
    return {
      pointsLogs:[],
      points:0,
      aa: {}
    }
  },
  watch: {
    aa: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue)
      },
      deep: true // 深度监听表单
    },
  },
  created() { },
  mounted() {
    this.getPoints()
    this.getPointsLogs()
  },
  methods: {
    // 获取用户积分
    getPoints() {
      let _this = this;
      _this.$get("/points/api/Points",).then((res) => {
          console.log(res.data);
          this.points = res.data.data || 0;
        })
    },
    // 获取用户积分
    getPointsLogs() {
      let _this = this;
      _this.$get("/points/api/Points/Logs",
      {
        page:1,
        size:10
      }
      ).then((res) => {
        console.log(res.data);
        this.pointsLogs = res.data.data.records
      })
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1)
    },
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  padding: 50px 0;
  background-color: #f9f9f9;
  .header-b {
    height: 208px;
    width: 100%;
    background-image: url("../../assets/mine/balance-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // background-color: #000;
    padding: 25px;
    .user-no {
      text-align: left;
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 17px;
      color: #ffffff;
    }
    .price {
      margin-top: 35px;
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      // line-height: 51px;
      color: #ffffff;
    }
    .tips {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 21px;
      color: #ffffff;
    }
    .h-btn {
      margin-top: 20px;
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;
      color: #ffffff;
      span {
        padding: 5px 10px;
        background-color: rgba(102, 94, 255, 0.1);
        border-radius: 4px;
      }
    }
  }
  //
  .list-tips {
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 800;
    line-height: 26px;
    color: #454f63;
    text-align: left;
    padding: 10px 15px 0;
  }
  .list {
    padding: 0 15px 30px;
  }
}
.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
</style>
